const CoveoPlaceHolderCardsLoader = ({ numberOfCards }) => {
	const dummyCards = new Array(numberOfCards).fill({});

	return (
		<div className="coveo-headless-content-cards-wrapper">
			<div
				className="coveo-headless-card-layout-container placeholder"
				data-qa="coveo-headless-card-layout-container"
			>
				{dummyCards.map((_, index) => {
					return (
						<div className="coveo-headless-card-layout" key={index}>
							<div className="coveo-headless-content-card">
								<div className="coveo-headless-content-card-text"></div>
								<div className="coveo-headless-content-card-classification">
									<p className="placeholder-pulse coveo-placeholder-card-eyebrow"></p>
								</div>
								<div className="coveo-headless-content-card-title">
									<p className="placeholder-pulse coveo-placeholder-card-title"></p>
								</div>
								<div className="coveo-headless-content-card-img placeholder-pulse">
									<wbr />
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default CoveoPlaceHolderCardsLoader;
